<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none" [ngClass]="{ 'kid-mobile-nav': isKid }">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between">
    <a class="nav-item fw-bold brand" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img
        alt=""
        class="home-logo"
        [src]="isKid ? ('logo/logo-kid.svg' | contentAssetImage) : ('logo/logo.svg' | contentAssetImage)"
        draggable="false"
      />
    </a>

    <!--Notifications-->
    <div class="toggle-notification">
      <div class="nav-item me-0">
        <fgb-notification-button></fgb-notification-button>
      </div>
      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <div class="mobile-nav-bar d-flex justify-content-space-between">
        <!-- Close Button -->
        <button
          class="close-button position-absolute border-0"
          attr.aria-label="{{ 'modal.close' | translate }}"
          (click)="isCollapsed = !isCollapsed"
        >
          <i class="material-icons close-btn">close</i>
        </button>
        <a class="nav-item fw-bold brand" [routerLink]="['/']" routerLinkActive="router-link-active">
          <label id="homeLink" class="accessibility-only">Go To Home Page</label>
          <img alt="" class="home-logo" [src]="'/logo/logo-dark.svg' | contentAssetImage" draggable="false" />
        </a>
      </div>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container">
        <a
          class="nav-item fw-bold large-item"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> account_circle </span>
            <div class="nav-text fw-bold">{{ 'account.nav.profile' | translate }}</div>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/rewards/raffles']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> redeem </span>
            <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
          </div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> trophy </span>
            <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
          </div>
        </a>

        <a class="nav-item" [routerLink]="['/gallery']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> animated_images </span>
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
          </div>
        </a>
        <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> sports_esports </span>
            <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
          </div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/worksheet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          *inPopulation="[populations.Kids]"
        >
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> tactic </span>
            <div class="nav-text fw-bold">{{ 'nav.worksheet' | translate }}</div>
          </div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <span class="material-symbols-outlined me-2"> account_balance_wallet </span>
            <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
          </div>
        </a>

        <button
          class="nav-item border-0 justify-content-between bg-white"
          attr.aria-label="{{ 'nav.help.screenreader' | translate : { fgbdefault: 'Click for help pages' } }}"
          (click)="isHelperCollapsed = !isHelperCollapsed"
        >
          <div class="d-flex align-items-center">
            <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">info</span>
            <div class="dropdown-link text-start">
              <div class="nav-text mt-0 fw-bold">{{ 'nav.help' | translate }}</div>
            </div>
          </div>
          <span
            [@expandAnimation]="isHelperCollapsed ? 'close' : 'open'"
            class="icon material-icons material-dropdown-icon m-0"
            aria-hidden="true"
            >keyboard_arrow_down</span
          >
        </button>
        <div class="sub-nav" *ngIf="isHelperCollapsed">
          <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.terms' | translate }}</div>
            </div>
          </a>
          <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
            </div>
          </a>
          <a
            class="nav-item"
            [routerLink]="['/contact']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</div>
            </div>
          </a>
        </div>

        <a class="logout-link-div" (click)="logout()">
          <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">logout</span>
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
